import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { X, Check, ShieldCheck, Download, Zap, GraduationCap } from 'lucide-react';
export function Objections() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank', 'noopener,noreferrer');
  };
  const noNeeds = ['NO necesitas experiencia previa', 'NO necesitas saber usar Amazon', 'NO necesitas conocimientos técnicos'];
  const benefits = ['Explicado paso a paso', 'Fácil de entender', 'Diseñado para principiantes', 'Aprende desde casa', 'Aprende a tu ritmo', 'Acceso inmediato después del pago', 'Compatible con celular y computadora'];
  return <section className="bg-brand-beige py-20 md:py-28 px-5 sm:px-6 relative overflow-hidden" data-id="element-460">
      {/* Subtle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40" data-id="element-461">
        <div className="absolute -top-32 right-0 w-[500px] h-[500px] bg-brand-gold/8 rounded-full blur-3xl" data-id="element-462"></div>
        <div className="absolute -bottom-32 left-0 w-[500px] h-[500px] bg-brand-green/5 rounded-full blur-3xl" data-id="element-463"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-464">
        <FadeIn data-id="element-465">
          <div className="text-center mb-12 max-w-3xl mx-auto" data-id="element-466">
            <div className="inline-flex items-center justify-center gap-2 bg-brand-green text-white border border-brand-gold/40 rounded-full px-5 py-2 mb-6 shadow-md" data-id="element-467">
              <GraduationCap className="w-4 h-4 text-brand-gold" data-id="element-468" />
              <span className="text-[11px] sm:text-xs font-bold tracking-[0.18em] uppercase text-brand-gold" data-id="element-469">
                Para principiantes
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green leading-[1.05] tracking-tight mb-6" data-id="element-470">
              Este sistema fue creado para principiantes
            </h2>
            <p className="text-base md:text-lg text-brand-text/75 leading-relaxed" data-id="element-471">
              Diseñado para ayudarte a entender paso a paso cómo funciona
              realmente Amazon FBA + FBM de forma práctica, clara y fácil de
              entender.
            </p>
          </div>
        </FadeIn>

        {/* NO NEEDS row */}
        <FadeIn delay={0.1} data-id="element-472">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10 md:mb-14" data-id="element-473">
            {noNeeds.map((item, i) => <div key={i} className="bg-white border border-brand-text/8 rounded-2xl px-5 py-4 flex items-center gap-3 shadow-[0_4px_20px_-8px_rgba(0,0,0,0.06)]" data-id="element-474">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-red-50 flex-shrink-0" data-id="element-475">
                  <X className="w-5 h-5 text-red-500" strokeWidth={2.5} data-id="element-476" />
                </span>
                <span className="text-sm md:text-base font-semibold text-brand-text leading-snug" data-id="element-477">
                  {item}
                </span>
              </div>)}
          </div>
        </FadeIn>

        {/* Benefits card */}
        <FadeIn delay={0.2} data-id="element-478">
          <div className="bg-white border border-brand-text/8 rounded-3xl p-7 md:p-10 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.1)] mb-10" data-id="element-479">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-gold mb-6 text-center" data-id="element-480">
              ✨ Lo que sí necesitas saber
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3.5" data-id="element-481">
              {benefits.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-482">
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-green flex-shrink-0 mt-0.5 shadow-sm" data-id="element-483">
                    <Check className="w-3 h-3 text-brand-gold" strokeWidth={3.5} data-id="element-484" />
                  </span>
                  <span className="text-sm md:text-base font-medium text-brand-text/85 leading-snug" data-id="element-485">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.3} data-id="element-486">
          <div className="text-center" data-id="element-487">
            <p className="font-serif text-xl md:text-2xl text-brand-green mb-7 flex items-center justify-center gap-3 tracking-tight" data-id="element-488">
              <span data-id="element-489">👉</span> Solo necesitas empezar con una guía clara
            </p>
            <Button onClick={goToCheckout} className="bg-brand-gold hover:bg-brand-gold/90 text-brand-green text-base md:text-lg font-bold px-10 py-5 shadow-2xl shadow-brand-gold/30 ring-1 ring-brand-gold/40" data-id="element-490">
              🚀 SÍ, QUIERO EMPEZAR
            </Button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-5" data-id="element-491">
              <span className="flex items-center gap-1.5" data-id="element-492">
                <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-493" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-494">
                <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-495" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-496">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-497" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}